import React from 'react';
const TYPE = {
  'food': '菜',
  'shopping': '购买'
};
export default function Tags(props){
  let { poiType, title, tagList, className } = props; 
  if(poiType && tagList.length){
    return(
      <section className={ className ? `basic-info recommend ${className}` : 'basic-info recommend'}>
        <h4>{title ? title : `推荐${TYPE[poiType]}`}</h4>
        <TagList2 tagList={tagList} />
      </section>
              
    );
  }else{
    return <TagList tagList={tagList} />;
  }  
}



function TagList(props){
  let { tagList } = props; 
  if(!tagList || tagList.length === 0 ) return null;
  return(
    <ul className="tags-wrap">
      {
        tagList.map((tag,index)=>{
          return <li key={index} className="tags">{tag}</li>;
        })
      }
    </ul>
          
  );
}


class TagList2 extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      neddShowMore: props.tagList.length > 6 ? true : false,
      showMore: false
    };
  }

  render(){
    let { tagList } = this.props; 
    let { neddShowMore,showMore } = this.state;
    if(!tagList || tagList.length === 0 ) return null;
    return(
      <ul className="tags-wrap">
        {
          tagList.map((tag,index)=>{
            if(showMore){
              return <li key={index} className="tags">{tag.recommend_name || tag.name}</li>;
            }else if(index < 6){
              return <li key={index} className="tags">
                {tag.recommend_name || tag.name}
              </li>;
            }
          })
        }
        {neddShowMore && !showMore? 
          <li key="more" className="tags" onClick={this.showMore}>
                        更多
            <i className="icon icon-arrow"></i>
          </li> : null 
        }
      </ul>
            
    );
  }

    showMore = ()=>{
      this.setState({
        showMore: true
      });
    }
    
}


// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/Tags.js